import { Platform } from "react-native";
import { ROUTE } from "../../routes";
import { CheckLimitInfoType } from "../../configs/constants";
let widthX = 0;
let heightX = 0;
let enableDimension = true;
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    widthX = action.payload.width;
    heightX = action.payload.height + 58;
    if (enableDimension) {
        const dimensionData = {
            height: heightX,
            width: widthX
        };
        if (Platform.OS === 'web') {
            // const dimensionEvent = new EventEmitter();
            // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
            //send message to parent iframe about dimension changes
            window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
        }
    }
};
export const st = async (action, _datastore, { navigateToBase, setDatastore, }) => {
    setDatastore(ROUTE.CHECK_LIMIT_VIEW_DETAIL, "assetSearch", {});
    // await navigateToBase(ROUTE.CHECK_LIMIT_SUCCESS)
};
export const goBack = async (action, _datastore, { navigateToBase }) => {
    console.warn("**** goToInit Action Triggered ****", action);
    await navigateToBase(ROUTE.CHECK_LIMIT_SUCCESS);
};
export const filterAction = async (action, _datastore, { navigateWithClear, removeWidgets, appendWidgets, setDatastore }) => {
    console.warn("**** filterAction Action Triggered ****", action);
    if (action.payload.value === true) {
        enableDimension = false;
        const dimensionData = {
            height: heightX,
            width: widthX - 56
        };
        if (Platform.OS === 'web') {
            // const dimensionEvent = new EventEmitter();
            // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
            //send message to parent iframe about dimension changes
            window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
        }
        await setDatastore(ROUTE.CHECK_LIMIT_VIEW_DETAIL, "CheckLimitViewDetailRootStack1", {
            hide: true
        });
        await setDatastore(ROUTE.CHECK_LIMIT_VIEW_DETAIL, "CheckLimitViewDetailRootStackHeader", {
            hide: true
        });
    }
    else {
        enableDimension = true;
        const dimensionData = {
            height: heightX,
            width: widthX + 56
        };
        if (Platform.OS === 'web') {
            // const dimensionEvent = new EventEmitter();
            // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
            //send message to parent iframe about dimension changes
            window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
        }
        await setDatastore(ROUTE.CHECK_LIMIT_VIEW_DETAIL, "CheckLimitViewDetailRootStack1", {
            hide: false
        });
        await setDatastore(ROUTE.CHECK_LIMIT_VIEW_DETAIL, "CheckLimitViewDetailRootStackHeader", {
            hide: false
        });
    }
};
export const openInfo = async (action, _datastore, { navigate }) => {
    console.warn("**** openInfo Action Triggered ****", action);
    const blockedReason = action?.payload?.item?.blockedReason;
    console.log("BlockedReason: ", blockedReason);
    switch (blockedReason) {
        case CheckLimitInfoType.LOCKED:
            navigate(ROUTE.CHECK_LIMIT_INFO, { title: 'Non eligibility reason', type: CheckLimitInfoType.LOCKED });
            break;
        case CheckLimitInfoType.UNAPPROVED:
            navigate(ROUTE.CHECK_LIMIT_INFO, { title: 'Non eligibility reason', type: CheckLimitInfoType.UNAPPROVED });
            break;
        case CheckLimitInfoType.DEMAT:
            navigate(ROUTE.CHECK_LIMIT_INFO, { title: 'Non eligibility reason', type: CheckLimitInfoType.DEMAT });
            break;
    }
};
